import { useTranslation } from '@msdk/common'
import { FieldProps } from '@msdk/forms'
import React from 'react'

import { MuSelectorAutocomplete } from './MuSelectorAutocomplete'

export function MuSelectorSource({ node, onChange }: FieldProps) {
  const t = useTranslation()
  const label: string = t('FRM_MEASUREMENT_UNIT_SOURCE', 'Measurement unit source')

  return (
    <>
      <MuSelectorAutocomplete node={node} onChange={onChange} label={label}></MuSelectorAutocomplete>
    </>
  )
}
